import { packeryEvents } from "vue-packery-plugin";
import { EventBus } from "../../../eventbus";
import symbols from "../../../../symbols/all";

export default {
  props: {
    activeView: String,
    doneSearching: Boolean,
    isSearch: Boolean,
    files: {
      type: Array,
      default: () => [],
    },
    mySpace: Number,
  },
  data() {
    return {
      id: this.$options.name,
      timer: false,
      contextMenuOptions: [],
      topId: "",
      intersectionOptions: {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: [0, 1], // [0.25, 0.75] if you want a 25% offset!
      },
      reachedEnd: false,
      fileShowCount: 0,
      isInView: false,
      lazyKey: 0,
      folderId: this.$route.params.id,
    };
  },
  created() {
    this.displayPlaceHolders();

    EventBus.$on(`${this.id}-layout`, () => {
      //this.resetMasonryLazyFiles();
      this.updateLayout();
    });

    EventBus.$on(`desktop-file-item--contextMenu`, this.openContextMenu);

    EventBus.$on(`item-actions--open`, (data) => {
      this.topId = data.id;
    });

    EventBus.$on(`item-actions--closed`, (data) => {
      if (this.topId === data.id) {
        this.topId = "";
      }
    });
  },
  methods: {
    setMySpace() {
      this.mySpace = this.$route.path.indexOf("myspace") !== -1 ? 1 : 0;
    },
    handleLayoutComplete() {
      if (this.isInView && this.fileShowCount !== this.files.length) {
        this.setFileShowCount();
      }
    },

    resetMasonryLazyFiles() {
      this.reachedEnd = false;
      this.fileShowCount = 0;
      this.isInView = true;
    },
    onWaypoint({ going }) {
      // going: in, out
      // direction: top, right, bottom, left
      if (!this.isInView) {
        this.isInView = going === "in";

        this.reachedEnd =
          going === "in" && this.fileShowCount <= this.files.length;

        this.setFileShowCount();
      }
    },
    openContextMenu(data) {
      this.contextMenuOptions = data.actions
        .filter((action) => action.name)
        .map((action) => {
          return {
            name: `${action.icon ? symbols[action.icon] : ""} ${action.name}`,
          };
        });

      if (this.$refs.vueSimpleContextMenu) {
        this.$refs.vueSimpleContextMenu.showMenu(data.e, data.actions);
      }
    },

    handleContextClick(e) {
      //check which button was pressed
      if (e.item) {
        e.item.forEach((item) => {
          if (e.option.name.includes(item.name)) {
            //run this function
            item.func();
          }
        });
      }
    },
    updateLayout() {
      this.doneUpdatingLayout = false;
      packeryEvents.$emit("reloadItems", this.$refs.packery);
      packeryEvents.$emit("layout", this.$refs.packery);
    },
    displayPlaceHolders() {
      this.timer = false;

      //wait before showing the placeholders
      setTimeout(() => {
        this.timer = true;
      }, 1500);
    },
    setFileShowCount() {
      if (this.files && this.isInView) {
        let newCount = this.fileShowCount;

        newCount += 20;

        if (newCount >= this.files.length) {
          newCount = this.files.length;
        }

        this.fileShowCount = newCount;
        this.updateLayout();
      }

      this.isInView = false;
    },
    checkUrlForBigChanges() {
      return this.$route.path.includes(
        `${this.$store.state.company}/${
          this.mySpace ? "myspace" : "home"
        }/expanded/${this.folderId}`
      );
    },
  },
  computed: {
    masonryFiles() {
      const files = [...this.files];

      return this.doneSearching ? files : 16;
    },
    forEachItems() {
      return this.doneSearching ? this.files : 16;
    },
    showPlaceHolders() {
      return (this.files.length === 0 && this.timer) || this.doneSearching;
    },
  },
  watch: {
    files(newFiles, oldFiles) {
      if (newFiles.length !== oldFiles.length) {
        //file length changed so update count
        this.fileShowCount = 0;
      }

      this.displayPlaceHolders();

      //update layout
      //this.updateLayout();
    },
    $route() {
      this.folderId = this.$route.params.id;

      if (!this.checkUrlForBigChanges()) {
        this.fileShowCount = 0;
      }
      //this.resetMasonryLazyFiles();
      //update layout
      //this.updateLayout();
    },
    doneSearching() {
      this.timer = false;
    },

    activeView() {
      //update layout
      this.updateLayout();
    },
  },
};
